// extracted by mini-css-extract-plugin
module.exports = {"Delivery":"Delivery_Delivery__1gBLE","NextButtonContainer":"Delivery_NextButtonContainer__hERqj","NextButton":"Delivery_NextButton__vkCjR","Active":"Delivery_Active__hSHjT"};